/** The grid of cards on pages reached from Create notice, e.g. Templates and Awards on Certificates, or Signatures. */
export const CREATE_CARD_GRID_SX = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
  gap: 2,
} as const;
